/**
 * Media URL resolver — backend returns relative paths like `/media/portfolio/foo.jpg`.
 * Frontend is served on a different host (tg.olabotardivna.com), so we prepend
 * the API host derived from VITE_API_URL.
 *
 * Idempotent: already-absolute URLs pass through unchanged.
 */

// Vite inlines `import.meta.env.VITE_API_URL` at build time. When the var
// isn't defined (e.g. a sibling app without its own .env), we still want
// media to load — fall back to the prod API host so paths resolve cleanly
// regardless of which frontend bundles this helper.
const PROD_API_FALLBACK = 'https://api.olabotardivna.com/api/v1';
const RAW_BASE = import.meta.env.VITE_API_URL || PROD_API_FALLBACK;
const API_BASE = RAW_BASE.replace(/\/api\/v\d+$/, '');

export function resolveMediaUrl(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  if (!API_BASE) return url;
  if (url.startsWith('/')) return `${API_BASE}${url}`;
  return url;
}
